export const data = {
  experience: [
    {
      title: "Frontend Developer Intern",
      subTitle: "Sitemaster | React.js, JavaScript, HTML, CSS",
      date: "Jan 2026 - Jun 2026",
      description:
        "Developed and maintained responsive interfaces, translated UI/UX designs into working features, and optimized web applications for speed and scalability.",
    },
    {
      title: "Research Intern",
      subTitle: "NIT Patna | Machine Learning & Computer Vision",
      date: "Jun 2024 - Jul 2024",
      description:
        "Improved underwater object recognition using image enhancement, Faster R-CNN, and YOLOv8, achieving 79% mAP on the URPC2020 dataset under low-contrast and occluded conditions.",
    },
    //   {
    //     title: "Senior Consultant",
    //     subTitle: "London, UK",
    //     description:
    //       "Web development, Databases, Backend developement",
    //   },
    //   {
    //     title: "Project Manager",
    //     subTitle: "Bangalore, INDIA",
    //     description:
    //       "Creative Direction Project Management, Team Leading",
    //   },
    // 
  ],
  education: [
    {
      title: "M.Tech in SPASE",
      subTitle: "Indian Institute of Technology Kanpur",
      date: "Jul 2026 - Jun 2028",
      description: "Space, Planetary & Astronomical Sciences & Engineering",
    },
    {
      title: "B.Tech in Information Technology",
      subTitle: "Indian Institute of Engineering Science and Technology, Shibpur, Howrah",
      date: "Dec 2021 - May 2025",
      description: "CGPA: 8.24",
    },
  ],
};
